import { useMediaQuery } from "@mui/material";
import IndieButton from "./IndieButton";

const { CancelRounded } = require("@mui/icons-material");
const { useTranslation } = require("react-i18next")

const IndieCancelButton = ({label, useAuthTests, ...params}) => {
    const { t } = useTranslation();
    const isUpSm = useMediaQuery((theme) => theme.breakpoints.up("sm"));

    return <IndieButton useAuthTests={useAuthTests} startIcon={<CancelRounded/>} variant="outlined" color="error" {...params}>{isUpSm && (label ? label : t("label.button.cancel"))}</IndieButton>
}

export default IndieCancelButton;